export class RedirectUrl {
  constructor(url) {
    window.location.href = `/panvel${url}`
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/redirect.js